import { useState, useEffect } from "react";
import Config from "../../Config";

import edit from "../../edit.png";

import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";


function SubkontoEdit(props)
{
    

    var numerK = props.row.numer_konta.replace(/\s/g,'');

    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({       
        id: props.row.id,   
        nazwa: props.row.nazwa,     
        numer_konta: numerK,
        nazwa_banku: props.row.nazwa_banku,
        bluemedia: props.row.bluemedia,
    });


 

    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     

            if(filedName == 'numer_konta' && correct)
            {
                setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct, ["nazwa_banku"]:msg,  ["nazwa_banku_valid"]:correct } ); 
            }else
            {
                setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
            }

    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const saveData = (e) => {



        if(row.numer_konta.length < 26) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj prawidłowy numer konta' ,  "ok"  ,null); 
                return; 
            }
    
            if(row.nazwa.length < 2) 
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj nazwę własną' ,  "ok"  ,null); 
                    return; 
                }

                
        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

       
     
        
 
        props.mainView.setProgress(-2);

        
        if(e != null)
            {
         
                e.target.innerHTML = "czekaj...";
            }

        var req =  row;


        fetch( Config.url + '/rest_v1_calc,subkonta_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Dane zostały zapisane" , "ok" , null);    
                       props.onClose();
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const changeView = () => {
        if(view == 'btn') {setView("dlg"); }  else setView('btn');      
    }     

 
    var itemsTN = [
        { v: '0', title: 'Nie - rodzice nie mogą płacić szybkim przelewem' }, 
        { v: '1', title: 'Tak - rodzice mogą płacić szybkim przelewem' }, 
    ];


    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Edycja konta do wpłat
                    </div>


                    <div className="dlg_content_x">


                                    <div className="form_tab">

                                         

                                        <div className="form_split"></div>

                                        <div className="form_control">
                                            <div className="fieldName">Numer rachunku bankowego*</div>
                                            <InputBankAccount   userData={props.userData} value={row.numer_konta} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="numer_konta" placeholder={"Numer konta: "} className=' w300 ' req='1'  />
                                        </div>



                                        <div className="form_split"></div>

                                        <div className="form_control">
                                            <div className="fieldName">Nazwa własna*</div>
                                            <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: np. Konto do wpłat, Tylko czesne, ... "} className=' w300 ' req='1' firstUp="1" />
                                        </div>


                                        <div className="form_split"></div>

                                        <div className="form_control">
                                            <div className="fieldName">Płatności OnLine*</div>
                                            <InputCombo  items={itemsTN} userData={props.userData} value={row.bluemedia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="bluemedia" placeholder={""} className='  ' req='1' firstUp="1" />
                                        </div>



                                        <div className="form_split"></div>

                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;

    

    return  <div>
                 <img  onClick={changeView}  className="ibtn" src={edit} title="Zmień dane"    />  
                {dlg_view} 
           </div>
}


export default SubkontoEdit;